<!-- 编辑销售单  (已废弃)-->
<template>
    <div class="business-content-main sales-order-edit">
        <div style="margin-right: 80px">
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <!--   form     -->
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="!showOrderMsg && submitData.EntpCusName">客户：{{ submitData.EntpCusName }}</span>
                    <span v-if="type == 7" style="font-size: 14px; margin-left: 10px; color: red"
                        >（ 温馨提醒：重新开单只会生成新的销售订单，将不影响旧的销售订单 ）</span
                    >
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="showReceipt()"
                        v-if="permission.moneyIn && (type == 1 || type == 2 || type == 5 || type == 8)"
                    >
                        {{ type == 5 ? permission.moneyIn : '收款记录' }}
                    </el-button>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="outWarehouse()"
                        v-if="(permission.goodOutAll || permission3.saleOut) && !submitData.IsDelivery && type == 6"
                        >整单出仓</el-button
                    >
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCustomer(1)"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7) && permission.addCustomer"
                        >{{ permission.addCustomer }}</el-button
                    >
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCustomer(2)"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7) && permission.editCustomer && submitData.EntpCusId"
                        >{{ permission.editCustomer }}</el-button
                    >
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-if="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="search-ctn" v-show="showOrderMsg">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择客户" prop="EntpCusId">
                                    <el-input v-if="type == 4" disabled v-model.trim="submitData.EntpCusName"></el-input>
                                    <el-select
                                        style="width: 100%"
                                        v-else
                                        :disabled="dataReadonly || type == 8"
                                        :loading="loading"
                                        v-model="submitData.EntpCusId"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        :remote-method="searchCustomer"
                                        @change="customerChange($event)"
                                        @visible-change="customerVisibleChange($event)"
                                        placeholder="输入客户名称/电话"
                                    >
                                        <el-option
                                            v-for="optionItem in customerList"
                                            :key="optionItem.EntpCusId"
                                            :data-msg="optionItem"
                                            :label="optionItem.EntpCusName"
                                            :value="optionItem.EntpCusId"
                                            ><span style="float: left">{{ optionItem.EntpCusName }}</span>
                                            <span style="float: right; color: #8492a6; font-size: 13px">{{ optionItem.CallNum }}</span></el-option
                                        >
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="业务员" prop="SId">
                                    <el-select
                                        v-model="submitData.SId"
                                        :disabled="dataReadonly"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="sIdChange($event)"
                                        @visible-change="siVisibleChange($event)"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="联系电话" prop="PhoneNum">
                                    <el-input :disabled="dataReadonly" v-model.trim="submitData.PhoneNum"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式" prop="ShipType">
                                    <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%">
                                        <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运输费用" prop="ShipAmount">
                                    <el-input min="0" type="number" step="0.01" :disabled="dataReadonly" v-model.trim="submitData.ShipAmount"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="结算方式" prop="PayType">
                                    <el-select v-model="submitData.PayType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%">
                                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="出仓仓库" prop="WarehouseId">
                                    <el-select
                                        v-model="submitData.WarehouseId"
                                        :disabled="dataReadonly"
                                        placeholder="请选择"
                                        style="width: 100%"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option
                                            v-for="optionItem in warehouseList"
                                            :key="optionItem.WarehouseId"
                                            :label="optionItem.WarehouseName"
                                            :value="optionItem.WarehouseId"
                                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                                        >
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6" v-if="funcConfig">
                            <div class="grid-content bg-purple">
                                <el-form-item label="跟单采购员" prop="SId">
                                    <el-select
                                        v-model="submitData.FollowerId"
                                        :disabled="dataReadonly"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="followerChange($event)"
                                        @visible-change="siVisibleChange($event)"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="item in FollowerList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="收货地址" prop="FullAddress">
                                    <el-autocomplete
                                        :disabled="dataReadonly"
                                        v-model.trim="submitData.FullAddress"
                                        style="width: 100%"
                                        :fetch-suggestions="querySearch"
                                    ></el-autocomplete>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="客人要求" class="grid-content bg-purple">
                                <el-tooltip :content="submitData.Remark" placement="top" effect="light" v-if="submitData.Remark && dataReadonly">
                                    <el-input :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                                </el-tooltip>
                                <el-input v-else :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>
                    商品明细
                    <span v-if="type == 8" style="font-size: 14px; margin-left: 10px; color: red">（ 温馨提醒：已出仓的商品不能再进行修改！ ）</span>
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="showSearch()"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7 || type == 8)"
                        >搜索配件</el-button
                    >
                </div>
            </div>
            <div class="edit-ctn">
                <!--      table title      -->
                <div @click="hideMsg()" class="div-table-row table-title">
                    <div class="div-table-cell" style="width: 5%">序号</div>
                    <div class="div-table-cell" style="width: 15%; flex-grow: 1"><span class="color-red">*</span>汽配编码</div>
                    <div class="div-table-cell" style="width: 15%"><span class="color-red">*</span>配件名称</div>
                    <div class="div-table-cell" style="width: 19%"><span class="color-red">*</span>车型</div>
                    <div class="div-table-cell" style="width: 6.5%">数量</div>
                    <div class="div-table-cell" style="width: 6.5%"><span class="color-red">*</span>单位</div>
                    <div class="div-table-cell" style="width: 7.5%">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                当配件商品有过报价历史时，显示配件商品的最新报价价格；<br />
                                若配件商品从未报价给客户时，则显示配件商品的零售价格
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        参考售价
                    </div>
                    <div class="div-table-cell" style="width: 8%">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格；<br />
                                若配件商品从未销售过，则不显示数值
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        销售价
                    </div>
                    <div class="div-table-cell" style="width: 7.5%">销售总价</div>
                    <div class="div-table-cell" style="width: 5%">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                若未选定出仓仓库，显示的留余数为总库存的商品留余数；<br />
                                若已选中出仓仓库，显示的留余数为该仓库下的商品留余数；<br />
                                注意：这里不统计退货的商品数量
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        留余
                    </div>
                    <div class="div-table-cell" style="width: 5%" v-if="type == 6 || type == 1">出仓</div>
                </div>
            </div>
        </div>
        <!-- table body -->
        <div
            id="infinite-list"
            class="infinite-list"
            :style="{ height: infiniteListHeight + 'px' }"
            v-infinite-scroll="loadDownScroll"
            infinite-scroll-distance="10"
            :infinite-scroll-immediate="false"
        >
            <div class="edit-ctn">
                <div @click="hideMsg()" class="table-main">
                    <div v-for="(item, index) in dataList" :key="index" style="margin-right: 80px">
                        <div v-if="index >= startIdx && index <= endIdx" class="div-table-row table-item" :ref="'pj' + index">
                            <div class="div-table-cell" style="width: 5%">
                                {{ index + 1 }}
                            </div>
                            <!--        编码            -->
                            <div class="div-table-cell div-table-cell-code" style="width: 15%; flex-grow: 1" :class="{ 'check-code-class': item.CodeRepeat }">
                                <img src="../../../assets/images/info.png" alt title="配件信息" class="info-icon" @click="showAPMsgDialog(item.EntpTempGoodsId)" />
                                <el-select
                                    :ref="'code' + index"
                                    :disabled="dataReadonly || type == 4 || (type == 8 && item.WarehousedCount > 0)"
                                    :loading="loading"
                                    allow-create
                                    default-first-option
                                    size="small"
                                    v-model="item.APCode"
                                    value-key="APCode"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="汽配编码"
                                    @focus="hideMsg"
                                    @change="codeChange($event, index)"
                                    @visible-change="apCodeVisibleChange($event)"
                                    @keyup.enter.native="addItem(true)"
                                    :remote-method="searchCode"
                                    popper-class="el-select-style-gray"
                                >
                                    <el-option
                                        v-for="optionItem in codeList"
                                        :key="optionItem.EntpTempGoodsId"
                                        :data-msg="optionItem"
                                        :label="optionItem.APCode"
                                        :value="optionItem.APCode"
                                    >
                                        <div class="option-content">
                                            <div class="project-Name">{{ optionItem.APCode }}</div>
                                            <div class="project-Name">{{ optionItem.GoodName }}</div>
                                            <div class="project-Name">
                                                {{ optionItem.AutoSerise }}
                                            </div>
                                            <div class="project-Name" v-if="changeCodeConfig">
                                                {{ optionItem.GoodCode }}
                                            </div>
                                        </div>
                                    </el-option>
                                </el-select>
                                <div v-if="item.State == 1" class="row-delete">已删除</div>
                            </div>
                            <!--        名称            -->
                            <div class="div-table-cell" style="width: 15%">
                                <el-input
                                    size="small"
                                    placeholder="配件名称"
                                    v-model="item.GoodName"
                                    v-if="item.IsNew"
                                    :disabled="dataReadonly || type == 4 || (type == 8 && item.IsDelivery)"
                                ></el-input>
                                <el-select
                                    v-else
                                    style="width: 100%"
                                    :disabled="dataReadonly || type == 4 || (type == 8 && item.WarehousedCount > 0)"
                                    :loading="loading"
                                    allow-create
                                    size="small"
                                    v-model="item.GoodName"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="配件名称"
                                    @focus="hideMsg"
                                    @change="nameChange($event, index)"
                                    @visible-change="apNameVisibleChange($event)"
                                    @keyup.enter.native="addItem(true)"
                                    :remote-method="
                                        query => {
                                            searchName(query, item);
                                        }
                                    "
                                    popper-class="el-select-style-gray"
                                >
                                    <el-option
                                        v-for="optionItem in nameList"
                                        :key="optionItem.EntpTempGoodsId"
                                        :data-msg="optionItem"
                                        :label="optionItem.GoodName"
                                        :value="optionItem.GoodName"
                                    >
                                        <div class="option-content">
                                            <div class="project-Name">{{ optionItem.GoodName }}</div>
                                            <div class="project-Name">{{ optionItem.APCode }}</div>
                                            <div class="project-Name">
                                                {{ optionItem.AutoSerise }}
                                            </div>
                                            <div class="project-Name" v-if="changeCodeConfig">
                                                {{ optionItem.GoodCode }}
                                            </div>
                                        </div>
                                    </el-option>
                                </el-select>
                            </div>
                            <!--        车系            -->
                            <div class="div-table-cell special-el-select" style="width: 19%">
                                <el-tooltip effect="dark" :content="item.AutoSerise ? item.AutoSerise.toString() : ''" :disabled="!item.AutoSerise" placement="top">
                                    <el-input
                                        size="small"
                                        v-model="item.AutoSerise"
                                        placeholder="车系"
                                        v-if="item.IsNew"
                                        :disabled="dataReadonly || type == 4 || (type == 8 && item.IsDelivery)"
                                    ></el-input>
                                    <el-select
                                        v-else
                                        :disabled="dataReadonly || type == 4 || (type == 8 && item.WarehousedCount > 0)"
                                        :loading="loading"
                                        allow-create
                                        size="small"
                                        v-model="item.AutoSeriseItem"
                                        :title="item.AutoSerise"
                                        value-key="EntpTempGoodsId"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        placeholder="车系"
                                        @focus="hideMsg"
                                        @visible-change="autoSeriseVisibleChange($event, item)"
                                        @keyup.enter.native="addItem(true)"
                                        :remote-method="
                                            query => {
                                                searchAutoSerie(query, item);
                                            }
                                        "
                                        @change="seriseChange($event, index)"
                                        popper-class="el-select-style-gray"
                                    >
                                        <el-option
                                            v-for="option in seriesList"
                                            :key="option.EntpTempGoodsId"
                                            :data-msg="option"
                                            :label="option.AutoSerise"
                                            :value="option"
                                        >
                                            <div class="option-content">
                                                <div class="project-Name" style="width: 300px">
                                                    {{ option.AutoSerise }}
                                                </div>
                                                <div class="project-Name">{{ option.GoodName }}</div>
                                                <div class="project-Name">{{ option.APCode }}</div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-tooltip>
                            </div>
                            <!--        数量            -->
                            <div class="div-table-cell" style="width: 6.5%">
                                <el-input
                                    type="number"
                                    :ref="'count' + index"
                                    :min="1"
                                    size="small"
                                    v-model="item.Count"
                                    @change="priceChange"
                                    @focus="hideMsg"
                                    @keyup.enter.native="addItem(true)"
                                    :disabled="dataReadonly || type == 4 || (type == 8 && item.WarehousedCount > 0)"
                                ></el-input>
                            </div>
                            <!--        单位         -->
                            <div class="div-table-cell unit-input-cell" style="width: 6.5%">
                                <el-select
                                    :disabled="dataReadonly || type == 4 || (type == 8 && item.WarehousedCount > 0)"
                                    default-first-option
                                    size="small"
                                    v-model="item.Unit"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="单位"
                                    @focus="hideMsg"
                                    @visible-change="unitVisibleChange($event)"
                                    @keyup.enter.native="addItem(true)"
                                    popper-class="el-select-style-gray"
                                >
                                    <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                                </el-select>
                            </div>
                            <!--        参考售价           -->
                            <div class="div-table-cell" style="width: 7.5%">
                                <img src="../../../assets/images/info.png" alt title="历史销售" class="info-icon" @click="showHistoryDialog(item.EntpTempGoodsId)" />
                                <el-tooltip effect="dark" :content="item.ReferencePrice.toString()" placement="top">
                                    <span>{{ item.ReferencePrice }}</span>
                                </el-tooltip>
                            </div>
                            <!--          销售价    区分是否计算利润      -->
                            <div
                                class="div-table-cell sales-input-cell"
                                v-if="(LoseMoneyValue && !dataReadonly && !(type == 8 && item.WarehousedCount > 0)) || (type == 8 && priceCanBeEdit)"
                                :class="{
                                    loseMoneyWarning: CheckLoseMoney(item.CostPrice, item.MarketPrice)
                                }"
                                style="width: 8%"
                            >
                                <el-tooltip :disabled="!CheckLoseMoney(item.CostPrice, item.MarketPrice)" effect="light" placement="right">
                                    <div slot="content">销售价低于成本价{{ LoseMoneyValue }}%</div>
                                    <el-input-number
                                        size="small"
                                        :min="0"
                                        :precision="2"
                                        :step="0.01"
                                        controls-position="right"
                                        v-model="item.MarketPrice"
                                        placeholder="销售价"
                                        @input="priceChange"
                                        @focus="hideMsg"
                                        @keyup.enter.native="addItem(true)"
                                    ></el-input-number>
                                </el-tooltip>
                            </div>
                            <div class="div-table-cell" style="width: 8%" v-else>
                                <el-input
                                    size="small"
                                    :min="0"
                                    :precision="2"
                                    :step="0.01"
                                    controls-position="right"
                                    v-model="item.MarketPrice"
                                    :disabled="dataReadonly || (type == 8 && item.WarehousedCount > 0) || (!priceCanBeEdit && type == 8)"
                                    placeholder="销售价"
                                    @input="priceChange"
                                    @focus="hideMsg"
                                    @keyup.enter.native="addItem(true)"
                                ></el-input>
                            </div>
                            <!--          销售总价          -->
                            <div class="div-table-cell" style="width: 7.5%">
                                <el-tooltip
                                    effect="dark"
                                    :content="(item.MarketPrice * item.Count ? (item.MarketPrice * item.Count).toFixed(2) : 0).toString()"
                                    placement="top"
                                >
                                    <span>
                                        {{ item.MarketPrice * item.Count ? (item.MarketPrice * item.Count).toFixed(2) : 0 }}
                                    </span>
                                </el-tooltip>
                            </div>
                            <!--   库存->留余=库存+待入-待出  -->
                            <div class="div-table-cell" style="width: 5%">
                                <el-tooltip
                                    effect="dark"
                                    :content="
                                        '待入仓(' +
                                        item.POrderWaitInQuantity +
                                        '）  待出仓(' +
                                        item.OrderWaitOutQuantity +
                                        '）  库存(' +
                                        (submitData.WarehouseId ? item.StorageInventory : item.Inventory) +
                                        '）'
                                    "
                                    placement="top"
                                >
                                    <span
                                        :class="{
                                            'color-red':
                                                (submitData.WarehouseId ? item.StorageInventory : item.Inventory) +
                                                    item.POrderWaitInQuantity -
                                                    item.OrderWaitOutQuantity <=
                                                0
                                        }"
                                        >{{
                                            (submitData.WarehouseId ? item.StorageInventory : item.Inventory) + item.POrderWaitInQuantity - item.OrderWaitOutQuantity
                                        }}</span
                                    >
                                </el-tooltip>
                            </div>
                            <!--        出仓            -->
                            <div class="div-table-cell" style="width: 5%" v-if="type == 6 || type == 1">
                                <el-button
                                    @click="outWarehouse(item)"
                                    size="mini"
                                    class="search-btn btn-primary"
                                    style="margin-left: 0"
                                    v-if="(permission.goodOut || permission3.saleOut) && !item.IsDelivery && type == 6"
                                    >出仓</el-button
                                >
                                <span v-if="type == 1">
                                    <el-tooltip effect="dark" :content="item.IsDelivery ? '已出仓' : item.WarehousedCount > 0 ? '部分出仓' : '未出仓'" placement="top">
                                        <span>{{ item.IsDelivery ? '已出仓' : item.WarehousedCount > 0 ? '部分出仓' : '未出仓' }}</span>
                                    </el-tooltip>
                                </span>
                            </div>
                            <el-button
                                class="less-btn"
                                icon="el-icon-minus"
                                circle
                                @click="delItem(index)"
                                v-if="type == 8 ? item.WarehousedCount == 0 : !dataReadonly && (type == 2 || type == 3 || type == 7)"
                            ></el-button>
                        </div>
                    </div>
                    <div class="infinite-loading" v-if="showInfiniteLoading"><i class="el-icon-loading" />加载中</div>
                    <div style="margin-right: 80px" v-else>
                        <div class="div-table-row table-item">
                            <div class="div-table-cell" style="width: 5%"></div>
                            <div class="div-table-cell" style="width: 15%; flex-grow: 1"></div>
                            <div class="div-table-cell" style="width: 15%"></div>
                            <div class="div-table-cell" style="width: 19%">总数量</div>
                            <div class="div-table-cell" style="width: 6.5%">
                                <el-tooltip effect="dark" :content="allNum.toString()" placement="top">
                                    <span>{{ allNum }}</span>
                                </el-tooltip>
                            </div>
                            <div class="div-table-cell" style="width: 6.5%"></div>
                            <div class="div-table-cell" style="width: 7.5%"></div>
                            <div class="div-table-cell" style="width: 8%">销售商品总额</div>
                            <div class="div-table-cell" style="width: 7.5%">
                                <el-tooltip effect="dark" :content="allMoney.toFixed(3).toString()" placement="top">
                                    <span>{{ allMoney.toFixed(3) }}</span>
                                </el-tooltip>
                            </div>
                            <div class="div-table-cell inventory-title" style="width: 5%" v-if="type == 6 || type == 1"></div>
                            <div class="div-table-cell" style="width: 5%"></div>
                        </div>
                        <el-button
                            class="add-btn"
                            type="primary"
                            icon="el-icon-plus"
                            circle
                            @click="addItem(true)"
                            v-if="!dataReadonly && (type == 2 || type == 3 || type == 7 || type == 8)"
                        ></el-button>
                    </div>
                </div>
                <div class="bottom-div">
                    <div class="ship-amount" v-if="noFee">
                        运费：<span class="discount-count">￥ {{ submitData.ShipAmount * 1 }}</span>
                    </div>
                    <div :class="['subzone', { 'no-fee': !noFee }]">
                        <div class="part">
                            <div class="dismoney">
                                <div class="distitle">
                                    <el-select v-model="discountId" :disabled="dataReadonly || type == 8" placeholder="请选择">
                                        <el-option v-for="item in discountOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
                                    </el-select>
                                </div>
                                <el-input-number
                                    v-if="discountId === 0"
                                    size="small"
                                    :disabled="dataReadonly || type == 8"
                                    v-model="submitData.DiscountAmount"
                                    :min="0"
                                    :step="0.01"
                                    :precision="2"
                                    controls-position="right"
                                    :max="Number(allMoney.toFixed(2))"
                                    style="width: 134px"
                                ></el-input-number>
                                <div class="percent-view" v-else>
                                    <el-input-number
                                        placeholder="请输入"
                                        :controls="false"
                                        :min="0"
                                        :max="100"
                                        :precision="2"
                                        :disabled="dataReadonly || type == 8"
                                        v-model="discountPercent"
                                    >
                                    </el-input-number>
                                    <span>%</span>
                                </div>
                            </div>
                        </div>
                        <div class="part">
                            <div>
                                <span style="margin: 0 12px" v-if="!noFee">=</span>
                                实收金额：<span class="discount-count">￥ {{ discountCount }}</span>
                            </div>
                            <div v-if="!dataReadonly && !showInfiniteLoading">
                                <el-button
                                    size="small"
                                    class="search-btn btn-primary"
                                    @click="submitForm(type, 0)"
                                    v-if="permission.save && type != 8"
                                    :disabled="saving"
                                    >{{ permission.save }}</el-button
                                >
                                <el-button size="small" class="search-btn btn-primary" @click="submitForm(type, 1)" v-if="permission.submit" :disabled="saving">{{
                                    permission.submit
                                }}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--   新增客户    -->
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑客户' : '新增客户'" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="1" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   财务收款    -->
        <el-dialog :close-on-click-modal="false" :title="type == 5 ? '申请收款' : '收款记录'" :visible.sync="ReceiptVisible" width="1300px">
            <div class="dialog-content" v-if="ReceiptVisible">
                <receipt ref="receipt" @closeReceipt="closeReceipt" :orderData="submitData" :type="type"></receipt>
            </div>
        </el-dialog>
        <!--   出仓     -->
        <el-dialog :close-on-click-modal="false" title="出仓" :visible.sync="outVisible" width="1000px">
            <div v-if="outVisible">
                <warehouseOut
                    :APList="warehouseGoodsList"
                    :OrderWarehouse="warehouseList.length > 0 ? warehouseList[0] : null"
                    :EntpCusOId="submitData.EntpCusOId"
                    @closeDialog="closeOutDialog"
                ></warehouseOut>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    :StorageId="submitData.WarehouseId"
                    :Source="0"
                    @closeDialog="closeSearchDialog"
                ></searchAP>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--  打印  -->
        <el-dialog :show-close="false" :close-on-click-modal="false" title="打印" :visible.sync="dialogPrintCHVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintCHVisible">
                <printContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1"></printContent>
            </div>
        </el-dialog>
        <!--  打印英文版  -->
        <el-dialog :show-close="false" :close-on-click-modal="false" title="打印英文销售单" :visible.sync="dialogPrintEngVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintEngVisible">
                <printEngContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1"></printEngContent>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="dialogPrint" :close-on-click-modal="false" width="500px">
            <div style="width: 100%; height: 100%; text-align: center; margin: 25px 0px 25px 0px">
                <span style="font-size: 16px" v-if="warehouseType == 0"> <i class="el-icon-info" style="color: #67c23a"></i>是否需要提交并打印？ </span>
                <span style="font-size: 16px" v-else> <i class="el-icon-info" style="color: #67c23a"></i>是否需要提交？ </span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="submit(0)" :disabled="saving">提交</el-button>
                <el-button size="mini" type="primary" @click="submit(1)" v-if="warehouseType == 0 && permission.print" :disabled="saving">提交，打印中文版</el-button>
                <el-button size="mini" type="primary" @click="submit(2)" :disabled="saving" v-if="warehouseType == 0 && permission.printEng">提交，打印英文版</el-button>
                <el-button size="mini" @click="canclePrint" :disabled="saving">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import printEngContent from '@/components/business/salesManage/printSalesEng';
import breadcrumb from '@/components/common/breadcrumb';
import customerEdit from '@/components/business/customerManage/customerEdit';
import receipt from '@/components/business/salesManage/receipt';
import warehouseOut from '@/components/business/salesManage/warehouseOut';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import APHistory from '@/components/common/APHistory';
import mixin from '@/mixins/mixin';
import { setTimeout } from 'timers';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        warehouseOut,
        receipt,
        searchAP,
        APMsg,
        APHistory,
        breadcrumb,
        // printContent,
        printEngContent
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.init();
                this.submitData = {};
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
            }
        },
        showOrderMsg() {
            let topValue = document.getElementById('infinite-list').scrollTop;
            this.scrollPosition = topValue;
        }
    },
    data() {
        let checkPhone = this.$util.checkPhone;
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            idList: [],
            addressList: [],
            postType: 0,
            dialogPrintCHVisible: false,
            dialogPrintEngVisible: false,
            dialogPrint: false,
            needConfirm: true,
            SIdList: [
                {
                    EmployeeId: userMsg.EmployeeId,
                    EmployeeName: userMsg.EmployeeName
                }
            ],
            FollowerList: [],
            EntpTempGoodsIdEdit: '',
            loading: false,
            saving: false,
            warehouseType: 0,
            dataReadonly: false,
            showOrderMsg: true,
            lack: false, // 库存是否紧缺
            APMsgVisible: false,
            historyVisible: false,
            searchVisible: false,
            ReceiptVisible: false,
            dialogVisible: false,
            outVisible: false,
            outItem: {},
            allNum: 1,
            allMoney: 0,
            customerEditType: 1,
            editIndex: -1,
            submitData: {
                SId: userMsg.EmployeeId,
                WarehouseId: '',
                WarehouseName: '',
                FollowerId: '',
                SubmissionState: false,
                EntpCusOId: '',
                UserId: userMsg.EmployeeId,
                ShipAmount: '',
                DiscountAmount: '',
                EntpCusId: '',
                PayType: null,
                ShipType: null,
                FullAddress: null,
                PhoneNum: '',
                Remark: '',
                DetailList: []
            },
            Limit: 10,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            unitList: [],
            warehouseList: [], //仓库列表
            warehouseGoodsList: [], //入库商品列表
            type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                ShipType: [
                    {
                        required: true,
                        message: '请选择发货方式',
                        trigger: 'blur'
                    }
                ],
                EntpCusId: [
                    {
                        required: true,
                        message: '请选择客户',
                        trigger: 'blur'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        message: '填写电话号码',
                        trigger: 'blur'
                    }
                ],
                FullAddress: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'change'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                WarehouseId: [{ required: true, message: '请选择仓库', trigger: 'blur' }]
            },
            permission: {},
            permission2: {},
            permission3: {},
            funcConfig: false,
            discountId: 0,
            discountOptions: [
                { id: 0, value: '优惠金额' },
                { id: 1, value: '整单优惠' }
            ],
            discountPercent: 0,

            startIdx: 0, // 列表显示的第一个列的下标
            endIdx: 49, // 列表显示的最后一个列的下标
            stopLoad: false, // 停止监听上下滚动
            windowHeight: window.innerHeight,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            scrollPosition: 0, // 滚动条位置，用于判断是否收起信息栏
            LoseMoneyValue: 0, //亏本指标
            priceCanBeZero: false,
            priceCanBeEdit: false,
            changeCodeConfig: false
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        this.getSendWay();
        this.getPay();
        this.getEntpFuncConfigData();
        this.getLoseMoneyValue();
        this.getPriceCanBeZeroValue();
        this.getEditPriceValue();
    },
    mounted() {
        let that = this;
        that.init();
        // 监听滚动事件
        document.addEventListener('scroll', that.loadTopScroll, true);
        window.onresize = () => {
            that.resetHeight();
        };
        // 给business-content强行写入css样式
        let bc = document.getElementsByClassName('business-content')[0];
        if (bc) {
            bc.style.overflow = 'hidden';
            bc.style.scrollbarWidth = 'none';
        }
        Vue.component('printContent', function (resolve) {
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printSales'], resolve);
                }
            });
        });
    },
    destroyed() {
        document.removeEventListener('scroll', this.loadTopScroll, true);
        let bc = document.getElementsByClassName('business-content')[0];
        bc.style.overflow = 'auto';
        bc.style.scrollbarWidth = 'auto';
    },
    computed: {
        // 是否显示loading
        showInfiniteLoading() {
            return this.endIdx < this.dataList.length - 1;
        },
        noFee() {
            return this.submitData.ShipAmount && this.submitData.ShipAmount * 1 !== 0;
        },
        // 优惠后的金额
        discountCount() {
            let discountCount = this.submitData.DiscountAmount;
            let shipAmount = this.submitData.ShipAmount ? this.submitData.ShipAmount * 1 : 0;
            if (!discountCount) {
                return (this.allMoney * 1 + shipAmount).toFixed(2);
            }
            if (this.discountId === 1) {
                // 处理整单优惠
                discountCount = (this.discountPercent / 100) * this.allMoney;
            }
            return (this.allMoney * 1 - discountCount + shipAmount).toFixed(2);
        }
    },
    methods: {
        getChangeCodeConfig() {
            this.$util.getSysConfig('ddhhm').then(data => {
                this.changeCodeConfig = data.Result;
            });
        },
        /**
         * 向上滚动
         * topValue: 距离顶部距离
         */
        loadTopScroll() {
            let topValue = document.getElementById('infinite-list').scrollTop;
            if (this.showOrderMsg && topValue > this.scrollPosition) {
                this.scrollPosition = topValue;
                this.hideMsg();
            }
            if (topValue > 150 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.startIdx > 0) {
                if (this.startIdx < 25) {
                    let over = this.startIdx;
                    this.startIdx -= Math.abs(over);
                    this.endIdx -= Math.abs(over);
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您现在在顶部'
                    });
                } else if (this.startIdx >= 25) {
                    this.startIdx -= 25;
                    this.endIdx -= 25;
                    if (this.startIdx === 0) {
                        this.$message({
                            type: 'info',
                            offset: this.windowHeight / 2,
                            message: '您现在在顶部'
                        });
                    } else {
                        // 对火狐浏览器做特殊处理
                        if (navigator.userAgent.indexOf('Firefox') >= 0) {
                            let sh = document.getElementById('infinite-list').scrollHeight / 4;
                            document.getElementById('infinite-list').scrollTop = sh;
                        }
                    }
                }
            }
            this.stopLoad = false;
        },
        // 向下滚动
        loadDownScroll() {
            let listLastIndex = this.dataList.length - 1;
            if (listLastIndex < 50 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.endIdx < listLastIndex) {
                if (this.endIdx + 25 <= listLastIndex) {
                    this.startIdx += 25;
                    this.endIdx += 25;
                    if (this.endIdx === this.listLastIndex) {
                        this.$message({
                            type: 'info',
                            offset: this.windowHeight / 2,
                            message: '您已经触底了哦~'
                        });
                    }
                } else {
                    let over = this.endIdx;
                    this.startIdx += listLastIndex - over;
                    this.endIdx += listLastIndex - over;
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您已经触底了哦~'
                    });
                }
            }
            this.stopLoad = false;
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        init() {
            let fullPath = this.$route.fullPath;
            document.onkeydown = event => {
                let isDialog = document.querySelector('.v-modal');
                let layui = document.querySelectorAll('.layui-layer');
                if (
                    fullPath == this.$route.fullPath &&
                    !this.APMsgVisible &&
                    !this.historyVisible &&
                    !this.searchVisible &&
                    !this.ReceiptVisible &&
                    !this.dialogVisible &&
                    !this.outVisible &&
                    !isDialog &&
                    layui.length <= 1
                ) {
                    let e = event || window.event || arguments.callee.caller.arguments[0];
                    if (e && e.keyCode == 13) {
                        // this.addItem(true);
                    }
                }
            };

            this.permission = this.$util.getPermission('salesOrder');
            this.permission3 = this.$util.getPermission('salesOrderTakeOut');

            this.id = this.$route.query.id;
            this.submitData.EntpCusOId = this.$route.query.id;
            this.type = Number(this.$route.query.type);

            let salesOrderModel = '';
            let datalist = '';
            switch (this.type) {
                case 1:
                    this.pageTitle = '查看销售单';
                    this.dataReadonly = true;
                    this.getOrderDetail();
                    break;
                case 2:
                    this.getChangeCodeConfig();
                    this.pageTitle = '编辑销售单';
                    salesOrderModel = this.$util.getLocalStorage('salesOrder');
                    datalist = this.$util.getLocalStorage('salesOrder_dataList');
                    //判断缓存是否有数据，如果有取缓存数据
                    if (salesOrderModel && datalist && datalist.length > 0) {
                        this.getDataFromChace();
                    } else {
                        this.getOrderDetail();
                    }
                    break;
                case 3:
                    this.getChangeCodeConfig();
                    this.pageTitle = '新增销售单';
                    salesOrderModel = this.$util.getLocalStorage('salesOrder');
                    datalist = this.$util.getLocalStorage('salesOrder_dataList');
                    //判断缓存是否有数据，如果有取缓存数据
                    if (salesOrderModel && datalist && datalist.length > 0) {
                        this.getDataFromChace();
                    } else {
                        this.addItem(false);
                        this.getdefaultWarehouses();
                    }
                    break;
                case 4:
                    this.getChangeCodeConfig();
                    this.pageTitle = '转为销售单';
                    this.getBJOrder();
                    break;
                case 5:
                    this.needConfirm = false;
                    this.pageTitle = '财务收款';
                    this.getOrderDetail();
                    break;
                case 6:
                    this.needConfirm = false;
                    this.pageTitle = '货物出仓';
                    this.getOrderDetail();
                    break;
                case 7:
                    this.pageTitle = '复制订单';
                    this.getOrderDetail();
                    break;
                case 8:
                    this.getChangeCodeConfig();
                    this.pageTitle = '修改订单';
                    salesOrderModel = this.$util.getLocalStorage('salesOrder');
                    datalist = this.$util.getLocalStorage('salesOrder_dataList');
                    //判断缓存是否有数据，如果有取缓存数据
                    if (salesOrderModel && datalist && datalist.length > 0) {
                        this.getDataFromChace();
                    } else {
                        this.getOrderDetail();
                    }
                    break;
                default:
                    break;
            }
            setTimeout(() => {
                this.resetHeight();
            }, 0);
        },
        refresh() {
            this.$router.replace({
                path: '/salesManage/salesOrder/edit',
                query: { id: '', type: 3 }
            });
            this.saving = false;
        },
        closePrintDialog() {
            this.dialogPrint = false;
            this.dialogPrintCHVisible = false;
            this.dialogPrintEngVisible = false;
            this.refresh();
        },
        canclePrint() {
            this.dialogPrint = false;
        },
        getSIdList() {
            this.$util.getSysConfig('sjqx').then(res => {
                if (res.Result) {
                    this.$util.getAuthSIdList().then(data => {
                        this.SIdList = data;
                    });
                    this.$util.getSIdList().then(data => {
                        this.FollowerList = data;
                    });
                } else {
                    this.$util.getSIdList().then(data => {
                        this.SIdList = data;
                        this.FollowerList = data;
                    });
                }
            });
        },
        getConfigData() {
            this.$util.getConfigData('Unit').then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog(items) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.APCode == e.APCode) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                        e.MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: 1,
                        MarketPrice: item.LatestPrice > 0 ? item.LatestPrice : '',
                        Unit: item.Unit,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        WarehousedCount: 0,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        State: 0
                    };
                    newGoodsList.push(newGoods);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }

            that.priceChange();
            that.searchVisible = false;
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
        },
        // 出仓
        outWarehouse(item) {
            this.warehouseGoodsList = [];
            if (item) {
                this.warehouseGoodsList.push({ ...item }); // 单个入仓
            } else {
                this.warehouseGoodsList = [...this.dataList]; // 整单入仓
            }
            this.outVisible = true;
        },
        closeOutDialog(edit, IsAllOutWarehouse) {
            this.outVisible = false;
            this.needConfirm = false;
            if (IsAllOutWarehouse) {
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
                return;
            }
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showOrderMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        checkCodeRepeat() {
            let repeatIndexs = [];
            let obj = {};
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                _dataList[i].CodeRepeat = false;
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }
            for (let key in obj) {
                if (obj[key].length >= 2) {
                    repeatIndexs = [...repeatIndexs, ...obj[key]];
                }
            }
            for (let j = 0; j < repeatIndexs.length; j++) {
                this.dataList[repeatIndexs[j]].CodeRepeat = true;
            }
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _lack = false; // 库存是否紧缺
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
                let _limit = 0;
                if (this.submitData.WarehouseId) {
                    _limit = DetailList[i].StorageInventory - DetailList[i].WaitingOutQuantity;
                } else {
                    _limit = DetailList[i].Inventory - DetailList[i].WaitingOutQuantity;
                }
                if (_limit <= 0) {
                    _lack = true;
                }
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.lack = _lack;
            this.dataList = DetailList;
        },
        // 显示收款
        showReceipt() {
            this.ReceiptVisible = true;
        },
        // 隐藏收款
        closeReceipt(edit, IsAllCollect) {
            this.ReceiptVisible = false;
            this.needConfirm = false;
            if (IsAllCollect) {
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
                return;
            }
            if (edit) {
                this.getOrderDetail();
            }
        },
        closeDialog(edit) {
            this.dialogVisible = false;
            if (edit) {
                this.searchCustomer();
            }
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        // 报价单转销售单详情
        getBJOrder() {
            this.getdefaultWarehouses();
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetQuotationOrderToSaleOrder',
                    data: {
                        QuoteId: this.id,
                        EntpId: this.userMsg.EntpId,
                        WarehouseId: this.submitData.WarehouseId
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    res.data.QuoteId = this.id;
                    res.data.UserId = this.userMsg.EmployeeId;
                    res.data.SId = this.userMsg.EmployeeId;
                    // res.data.WarehouseId = "";
                    // res.data.WarehouseName = "";
                    res.data.WarehouseId = this.submitData.WarehouseId;
                    res.data.WarehouseName = this.submitData.WarehouseName;
                    res.data.DiscountAmount = 0;
                    this.submitData = res.data;
                    let _lack = false; // 库存是否紧缺
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        if (DetailList[i].Inventory - DetailList[i].WaitingOutQuantity <= 0) {
                            _lack = true;
                        }
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                    }
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.lack = _lack;
                    this.dataList = DetailList;
                });
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetEntpCusSaleOrder',
                    data: {
                        EntpCusOId: this.id,
                        Type: this.type
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    data.QuoteId = this.id;
                    data.SubmissionState = Boolean(data.SubmissionState);
                    data.UserId = this.userMsg.EmployeeId;
                    this.submitData = data;
                    // 判断是否可编辑
                    if (this.type != 2 && this.type != 3 && this.type != 7 && this.type != 8) {
                        this.dataReadonly = true;
                    }
                    this.customerList.push({
                        EntpCusId: res.data.EntpCusId,
                        EntpCusName: res.data.EntpCusName,
                        CallNum: res.data.PhoneNum,
                        FullAddress: res.data.FullAddress
                    });

                    let i = this.SIdList.findIndex(item => {
                        if (item.EmployeeId == res.data.SId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        this.SIdList.push({
                            EmployeeId: res.data.SId,
                            EmployeeName: res.data.SName
                        });
                    }

                    this.FollowerList.push({
                        EmployeeId: res.data.FollowerId,
                        EmployeeName: res.data.FollowerName
                    });

                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    } else {
                        this.getdefaultWarehouses();
                    }

                    let _lack = false; // 库存是否紧缺
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        this.$set(DetailList[i], 'MarketPrice', DetailList[i].Price);
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        let _limit = 0;
                        if (this.submitData.WarehouseId) {
                            _limit = DetailList[i].StorageInventory - DetailList[i].WaitingOutQuantity;
                        } else {
                            _limit = DetailList[i].Inventory - DetailList[i].WaitingOutQuantity;
                        }
                        if (_limit <= 0) {
                            _lack = true;
                        }
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                    }

                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.lack = _lack;
                    this.dataList = DetailList;
                });
        },
        // 提交销售单
        submitForm(type, SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;
                    if (!this.submitData.EntpCusId && this.type != 4) {
                        this.$util.warningMsg('请选择客户');
                        this.showMsg();
                        return;
                    }
                    if (this.discountId === 1) {
                        // 处理整单优惠
                        this.submitData.DiscountAmount = (this.discountPercent / 100) * this.allMoney;
                    }
                    if (this.submitData.DiscountAmount > this.allMoney) {
                        this.$util.warningMsg('优惠金额不能大于订单总额');
                        return;
                    }
                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }
                        if (!_dataList[i].AutoSerise) {
                            this.$util.warningMsg('请填写车型');
                            return;
                        }
                        if (!_dataList[i].Count || _dataList[i].Count < 0) {
                            this.$util.warningMsg('请填写正确的数量');
                            return;
                        }
                        if (!_dataList[i].Unit) {
                            this.$util.warningMsg('请填写单位');
                            return;
                        }
                        if (!_dataList[i].MarketPrice) {
                            this.$util.warningMsg('销售价不能小于0');
                            return;
                        }
                        if (!this.priceCanBeZero) {
                            if (!_dataList[i].MarketPrice && !_dataList[i].Price) {
                                this.$util.warningMsg('请填写销售价');
                                return;
                            }
                            if (_dataList[i].MarketPrice == 0) {
                                this.$util.warningMsg('销售价不能为0');
                                return;
                            }
                        }
                        if (_dataList[i].MarketPrice) {
                            _dataList[i].Price = _dataList[i].MarketPrice;
                        }
                    }

                    this.postType = type;
                    this.submitData.DetailList = _dataList;
                    this.submitData.SubmissionState = SubmissionState;
                    switch (SubmissionState) {
                        case 0: //保存
                            this.submit(0); //不打印
                            break;
                        case 1: //提交
                            this.dialogPrint = true;
                            break;
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        submit(printType) {
            let that = this;
            if (that.saving) return;
            that.saving = true; //防止多次点击
            that.dialogPrint = false;

            let type = Number(that.postType);
            let url = '';
            switch (type) {
                case 2: // 2 是编辑（未提交前）；
                    url = '/api/EntpSaleOrder/Save';
                    break;
                case 3: // 3 是新增；
                    url = '/api/EntpSaleOrder/Save';
                    break;
                case 8: // 8 是修改（提交后）
                    url = '/api/EntpSaleOrder/SaveAfterSubmit';
                    break;
                case 7: // 7 是重新开单
                    url = '/api/EntpSaleOrder/RebuildSaleOrder';
                    break;
            }
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.needConfirm = false;

                        that.idList = [];
                        if (res.data) {
                            //新增
                            that.idList.push(res.data);
                        } else {
                            //修改
                            that.idList.push(that.id);
                        }

                        if (type == 2 || type == 3 || type == 7) {
                            let name = '';
                            switch (that.submitData.SubmissionState) {
                                case 0:
                                    name = '保存';
                                    break;
                                case 1:
                                    name = '提交';
                                    break;
                            }
                            that.$util.successMsg(name + '销售订单成功');
                        } else if (type == 8) {
                            that.$util.successMsg('修改销售订单成功');
                        } else {
                            that.$util.successMsg('转为销售订单成功');
                        }
                        //清除销售订单缓存
                        that.removePageChace();

                        let CacheList = [];

                        //添加默认出仓仓库
                        if (that.submitData.WarehouseId) {
                            var wd = {
                                WarehouseId: that.submitData.WarehouseId,
                                WarehouseName: that.submitData.WarehouseName,
                                WarehouseType: that.warehouseType
                            };
                            CacheList.push({ CacheKey: 'defaultOutWarehouses', CacheValue: JSON.stringify(wd), CacheType: '1' });

                            that.$util.SetEntpCache(CacheList);
                        }

                        switch (printType) {
                            case 1:
                                that.dialogPrintCHVisible = true;
                                break;
                            case 2:
                                that.dialogPrintEngVisible = true;
                                break;
                            case 0:
                                that.$store.commit('updateNeedRefresh', true);
                                setTimeout(() => {
                                    that.$router.push('/salesManage/salesOrder');
                                }, 2000);
                                break;
                        }
                    }
                })
                .catch(() => {
                    that.saving = false;
                });
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
            this.addPageChace(); //添加销售订单缓存
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].MarketPrice) {
                        this.$util.warningMsg('请填写销售价');
                        return;
                    }
                }
            }
            if (addPageChace) {
                this.addPageChace(); //添加销售订单缓存
            }

            this.dataList.push({
                WaitingOutQuantity: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                ReferencePrice: 0,
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: '1',
                MarketPrice: '',
                CostPrice: 0,
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                IsNew: false,
                WarehousedCount: 0,
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                State: 0
            });

            // 当dataList数量大于50时
            if (this.dataList.length > 50) {
                this.startIdx += 1;
                this.endIdx += 1;
            }

            // 新增一行数据的时候，元素定位到底部
            setTimeout(() => {
                let ilEle = document.getElementById('infinite-list');
                ilEle.scrollTop = ilEle.scrollHeight + 50;
            }, 0);

            this.priceChange();
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage('salesOrder', this.submitData);
            this.$util.setLocalStorage('salesOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('salesOrder');
            this.$util.clearLocalStorage('salesOrder_dataList');
        },
        //从缓存中读取数据
        getDataFromChace() {
            let salesOrderModel = this.$util.getLocalStorage('salesOrder');
            let datalist = this.$util.getLocalStorage('salesOrder_dataList');
            if (salesOrderModel) {
                this.submitData = salesOrderModel;
                this.customerList.push({
                    EntpCusId: salesOrderModel.EntpCusId,
                    EntpCusName: salesOrderModel.EntpCusName,
                    CallNum: salesOrderModel.PhoneNum,
                    FullAddress: salesOrderModel.FullAddress
                });
                let i = this.SIdList.findIndex(item => {
                    if (item.EmployeeId == salesOrderModel.SId) {
                        return true;
                    }
                });
                if (i == -1) {
                    this.SIdList.push({
                        EmployeeId: salesOrderModel.SId,
                        EmployeeName: salesOrderModel.SName
                    });
                }

                this.FollowerList.push({
                    EmployeeId: salesOrderModel.FollowerId,
                    EmployeeName: salesOrderModel.FollowerName
                });
            }
            if (salesOrderModel && salesOrderModel.WarehouseId) {
                this.warehouseList.push({
                    WarehouseId: salesOrderModel.WarehouseId,
                    WarehouseName: salesOrderModel.WarehouseName,
                    Type: salesOrderModel.WarehouseType
                });
            } else {
                this.getdefaultWarehouses();
            }

            if (datalist && datalist.length > 0) {
                let _lack = false; // 库存是否紧缺
                let _allNum = 0;
                let _allMoney = 0;
                for (let i = 0; i < datalist.length; i++) {
                    _allNum += Number(datalist[i].Count);
                    _allMoney += datalist[i].Count * datalist[i].MarketPrice ? datalist[i].Count * datalist[i].MarketPrice : 0;
                    let _limit = 0;
                    if (this.submitData.WarehouseId) {
                        _limit = datalist[i].StorageInventory - datalist[i].WaitingOutQuantity;
                    } else {
                        _limit = datalist[i].Inventory - datalist[i].WaitingOutQuantity;
                    }
                    if (_limit <= 0) {
                        _lack = true;
                    }
                }
                this.allMoney = _allMoney;
                this.allNum = _allNum;
                this.lack = _lack;
                this.dataList = datalist;
            }
        },
        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                this.$util.getSysConfig('xskdmrck').then(data => {
                    if (data && data.Result) {
                        this.$util.GetEntpCache({ CacheKey: 'defaultOutWarehouses', CacheType: '1' }, true).then(result => {
                            if (result) {
                                let data = JSON.parse(result);
                                let isexit = this.warehouseList.find(e => e.WarehouseId == data.WarehouseId);
                                if (!isexit) {
                                    this.warehouseList.push({
                                        WarehouseId: data.WarehouseId,
                                        WarehouseName: data.WarehouseName,
                                        Type: data.WarehouseType
                                    });
                                }

                                this.$set(this.submitData, 'WarehouseId', data.WarehouseId);
                                this.$set(this.submitData, 'WarehouseName', data.WarehouseName);

                                this.warehouseType = data.WarehouseType;
                            }
                            resolve();
                        });
                    } else {
                        resolve();
                    }
                });
            });
        },

        /**
         * 获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * FullAddress 收货地址
         */
        getDefaultData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: this.submitData.EntpCusId,
                        type: '0',
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        let dIndex = this.DeliveryMethodList.findIndex(f => f.Value == data.ShipType);
                        if (dIndex == -1) {
                            this.DeliveryMethodList.push({
                                Value: data.ShipType,
                                Text: data.ShipTypeName
                            });
                        }
                        this.submitData.ShipType = data.ShipType;

                        dIndex = this.payWayList.findIndex(f => f.Value == data.PayType);
                        if (dIndex == -1) {
                            this.payWayList.push({
                                Value: data.PayType,
                                Text: data.PayTypeName
                            });
                        }
                        this.submitData.PayType = data.PayType;
                        this.submitData.FullAddress = data.FullAddress;
                    }
                });
        },
        // 搜索顾客
        searchCustomer(key) {
            this.loading = true;
            this.customerList = [];
            this.$util
                .searchCustomer(key)
                .then(data => {
                    this.customerList = data;
                    //修改客户时要更新页面上展现的名称
                    if (this.customerList.length > 0) {
                        let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                        if (currCust) {
                            this.submitData.EntpCusName = currCust.EntpCusName;
                            this.submitData.PhoneNum = currCust.CallNum;
                            this.addressList = [];
                            //这里要处理多个地址问题
                            if (currCust.FullAddress) {
                                if (currCust.FullAddress.indexOf('{$}') != -1) {
                                    let addressArray = currCust.FullAddress.split('{$}');
                                    addressArray.forEach((e, i) => {
                                        this.addressList.push({
                                            value: e
                                        });
                                    });
                                    this.submitData.FullAddress = addressArray[0];
                                } else {
                                    this.submitData.FullAddress = currCust.FullAddress;
                                }
                            }
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 搜索汽配编码
        searchCode(key) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        APCode: key,
                        Limit: this.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.codeList = res.data;
                });
        },
        // 搜索名称
        searchName(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        GoodName: key,
                        Limit: this.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.nameList = res.data;
                    if (item) {
                        item.VGoodName = key;
                        item.GoodName = key;
                        this.seriesList = res.data;
                    }
                });
        },
        // 搜车系
        searchAutoSerie(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        GoodName: item ? item.VGoodName : '', //配合商品名称查
                        Limit: this.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        OnlySeries: true,
                        SeriesName: key
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.seriesList = res.data;
                });
        },
        //获取企业的功能设置结果
        getEntpFuncConfigData() {
            this.$util.getSysConfig('xsgdy').then(res => {
                this.funcConfig = res.Result;
            });
        },
        //获取销售商品亏本指标
        getLoseMoneyValue() {
            this.$util.getSysConfig('xskbzb').then(res => {
                this.LoseMoneyValue = res.Result ? Number(res.RValue) : 0;
            });
        },
        //获取销售价可为零配置
        getPriceCanBeZeroValue() {
            this.$util.getSysConfig('xsspjgwl').then(res => {
                this.priceCanBeZero = res.Result;
            });
        },
        getEditPriceValue() {
            this.$util.getSysConfig('xgxsjg').then(res => {
                this.priceCanBeEdit = res.Result;
            });
        },
        //结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        //检查是否亏本
        CheckLoseMoney(costPrice, salePric) {
            let that = this;
            if (!that.LoseMoneyValue || !costPrice || !salePric) return false;

            let val = Number(salePric) * ((100 - that.LoseMoneyValue) / 100) < Number(costPrice);
            return val;
        },
        // 名称改变
        nameChange(value, index) {
            this.editIndex = index;
            if (!value) {
                this.dataList[index].VGoodName = '';
                return;
            }
            let _list = this.nameList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].GoodName == value) {
                    if (!this.dataList[index].APCode) {
                        this.dataList[index].APCode = _list[i].APCode;
                        this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                        this.dataList[index].State = 0;
                    }
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].VGoodName = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';

                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;
                    break;
                }
            }
            this.checkCodeRepeat();
            this.priceChange();
        },
        // 编码改变
        codeChange(value, index) {
            let isNew = true;
            this.checkCodeRepeat();
            this.editIndex = index;
            // this.searchCode();
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].APCode == value) {
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;

                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    // this.dataList[index].MarketPrice = _list[i].MarketPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';
                    this.dataList[index].State = 0;
                    isNew = false;

                    break;
                }
            }
            if (isNew && value) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].StorageInventory = 0;
                        that.dataList[index].MarketPrice = '';
                        that.dataList[index].ReferencePrice = 0;
                        that.dataList[index].State = 0;
                        that.dataList[index].IsNew = true;
                        that.$nextTick(() => {
                            that.$refs['code' + index][0].blur();
                        });
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].AutoSeriseItem = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                }
                            });
                    }
                });
            }
            this.priceChange();
        },

        //车型改变 AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
        seriseChange(item, index) {
            this.editIndex = index;
            if (!item) {
                this.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                this.dataList[index].AutoSerise = item;
            } else {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].State = 0;
                this.dataList[index].CostPrice = item.CostPrice;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].ReferencePrice = item.ReferencePrice;
                this.dataList[index].MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.checkCodeRepeat();
                this.priceChange();
            }
        },
        // 客户改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
                that.submitData.PhoneNum = '';
                that.addressList = [];
                that.submitData.FullAddress = '';
            } else {
                //获取客户的名称、手机号、地址等数据
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                    that.submitData.PhoneNum = currCust.CallNum;
                    that.addressList = [];
                    //这里要处理多个地址问题
                    if (currCust.FullAddress) {
                        if (currCust.FullAddress.indexOf('{$}') != -1) {
                            let addressArray = currCust.FullAddress.split('{$}');
                            addressArray.forEach((e, i) => {
                                that.addressList.push({
                                    value: e
                                });
                            });
                            that.submitData.FullAddress = addressArray[0];
                        } else {
                            that.submitData.FullAddress = currCust.FullAddress;
                        }
                    }
                }
                //查询对客户最新的商品销售价格
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsLatestPriceByCId',
                                data: {
                                    cId: value,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getGoods = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getGoods) {
                                        // e.HidePrice=getGoods.MarketPrice;
                                        //替换销售价
                                        e.MarketPrice = getGoods.Price;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
            this.getDefaultData();
        },
        //查地址列表
        querySearch(queryString, cb) {
            var restaurants = this.addressList;
            cb(restaurants);
        },
        //业务员改变
        sIdChange(value) {
            let _list = this.SIdList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.SName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //跟单采购员的改变
        followerChange(value) {
            let _list = this.FollowerList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.FollowerName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        // 改变商品数量
        handleNumChange(data, value, index) {
            this.dataList[index].Count = value;
        },

        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.nameList.length == 0) that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event) {
                if (that.seriesList.length == 0) that.searchAutoSerie('', item);
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        that.warehouseType = that.warehouseList[i].Type;
                        break;
                    }
                }
                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.el-form-item {
    margin-bottom: 0px;
}
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 40%;
    float: left;
}
.form-uploadImg {
    margin-bottom: 20px;
}
.form-uploadImg div {
    width: 100%;
    font-size: 14px;
    margin-bottom: 10px;
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
    padding-bottom: 180px;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
</style>
<style lang="less">
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.loseMoneyWarning {
    .el-input__inner {
        border: 1px solid #e6a23c;
    }
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 20px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.special-el-select {
    .el-select {
        width: 100%;
    }
}
.bottom-div {
    margin-top: 30px;
    margin-right: 80px;
    padding-bottom: 180px;
    .ship-amount {
        text-align: right;
        margin-bottom: 16px;
        .discount-count {
            font-size: 15px;
            font-weight: bold;
            color: #f00;
        }
    }
    .part {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 16px;
    }
    .no-fee {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
    .subzone {
        .dismoney {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 32px;
            .percent-view {
                display: flex;
                align-items: center;
                span {
                    margin-left: 12px;
                }
            }
            .el-input-number {
                width: 110px;
                .el-input__inner {
                    height: 32px;
                }
            }
            .el-select {
                margin-right: 12px;
                .el-input__inner {
                    width: 110px;
                    height: 32px;
                    color: red;
                }
                .el-input__suffix {
                    top: 4px;
                }
                .is-focus {
                    .el-input__suffix {
                        top: -4px;
                    }
                }
            }
        }
        .discount-count {
            font-size: 15px;
            font-weight: bold;
            color: #f00;
        }
    }
}
.sales-order-edit {
    .sales-input-cell {
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }
}
</style>
